import { filter, uniqBy } from 'lodash'

import validatesMultiSelect from 'helpers/validates/multiSelect'

const toggleSelectByGroup = (selectedItems, allItems, group) => {
  if (validatesMultiSelect.allSelectedByGroup(selectedItems, allItems, group)) {
    return filter(selectedItems, (item) => item.group !== group)
  }

  return uniqBy([...selectedItems, ...filter(allItems, ['group', group])], 'id')
}

export default toggleSelectByGroup
